<template>
  <div>
    <div>
      <b>子どもID</b>
      <span class="pr-3">： {{ consultation.childId }}</span>
    </div>
    <div>
      <b>ユーザID</b>
      <span class="pr-3">： {{ consultation.userId }}</span>
    </div>
    <div>
      <span><b>クーポン名</b>： {{ consultation.userCouponName }}</span>
    </div>
    <child-full-property
      :object="consultation"
      :is-child-name-displayable="false"
    />
  </div>
</template>

<script>
import ChildFullProperty from "../ChildFullProperty.vue";

export default {
  name: "AnytimeConsultationPediatricianUserInfo",
  components: {
    ChildFullProperty
  },
  props: {
    consultation: {
      type: Object,
      default: null
    },
  },
};
</script>
